import React, { FC, useEffect } from "react";
import { Link } from "react-router-dom";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import CalculatorIframe from "./components/CalculatorIframe";

const CalculatorPage: FC = () => {
  useEffect(() => {
    document.title = "Earnings calculator — StarFarm";
  }, []);

  return (
    <div
      style={{
        minHeight: "100vh",
        width: "100%",
        margin: 0,
        padding: 0,
        backgroundColor: "#0b0d20",
      }}
    >
      <Box
        component="header"
        style={{
          maxWidth: 1080,
          margin: "0 auto",
          padding: "16px 20px 0",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: 12,
        }}
      >
        <Link
          to="/"
          style={{
            color: "rgba(255,255,255,0.85)",
            textDecoration: "none",
            fontSize: 14,
            fontWeight: 500,
            letterSpacing: 0.3,
          }}
        >
          ← StarFarm home
        </Link>
        <Typography
          component="span"
          style={{
            color: "rgba(255,255,255,0.45)",
            fontSize: 12,
            letterSpacing: 1.5,
            textTransform: "uppercase",
          }}
        >
          Artist payout calculator
        </Typography>
      </Box>

      <CalculatorIframe />
    </div>
  );
};

export default CalculatorPage;
